import { render, staticRenderFns } from "./DailyResults.vue?vue&type=template&id=705ceb05&scoped=true&"
import script from "./DailyResults.vue?vue&type=script&lang=js&"
export * from "./DailyResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ceb05",
  null
  
)

export default component.exports